// pages/mim-balance.js
import React, { useEffect, useState } from "react";
import moment from "moment";
import axios from "axios";
import "./Styles/table.css";

const WalletRecharge = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [receipts, setReceipts] = useState<any[]>([]);
  const [modalImage, setModalImage] = useState<string | null>(null);
  const [approveModal, setApproveModal] = useState<{ open: boolean, item: any | null, remarks: string }>({ open: false, item: null, remarks: '' });
  const [approveLoading, setApproveLoading] = useState(false);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchReceipts = async () => {
      try {
        const response = await axios.get(
          'https://app.myimpactmeter.com/api/v2/prod/admin/adminPortal/getAllUploadReceipts',
          {
            headers: {
              'x-source': 'admin-portal',
            },
          }
        );
        setReceipts(response.data.data || []);
      } catch (err) {
        console.error('Error fetching receipts:', err);
        setError(err.response?.data?.message || 'Something went wrong');
      }
    };

    fetchReceipts();
  }, []);



  // Approve handler function (not a separate component)
  const handleApprove = async () => {
    if (!approveModal.item) return;
    setApproveLoading(true);
    try {
      await axios.post(
        'https://app.myimpactmeter.com/api/v2/prod/admin/adminPortal/approveWalletRechargeRequest',
        {
          remarks: approveModal.remarks,
          receiptId: approveModal.item._id
        },
        {
          headers: { 'x-source': 'admin-portal' }
        }
      );
      setReceipts((prev: any[]) => prev.map(r => r._id === approveModal.item._id ? { ...r, isApproved: 'approved', remarks: approveModal.remarks } : r));
      setApproveModal({ open: false, item: null, remarks: '' });
    } catch (err) {
      alert('Approval failed!');
    } finally {
      setApproveLoading(false);
    }
  };




  return (
    <div style={{ padding: 0, width: '100vw', minHeight: '100vh', background: '#181818', fontFamily: 'Arial, sans-serif' }}>
      <h2 style={{ marginBottom: '20px', color: 'white', fontSize: '32px', fontWeight: 'bold', textAlign: 'center', letterSpacing: 1 }}>Wallet Recharge with Approval</h2>
      <div className="table">
        {modalImage && (
          <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
          }}
            onClick={() => setModalImage(null)}
          >
            <img src={modalImage} alt="Large" style={{ maxHeight: '90vh', maxWidth: '90vw', border: '4px solid white', borderRadius: 8 }} />
          </div>
        )}
        {approveModal.open && (
          <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000
          }}>
            <div style={{ background: 'white', padding: 32, borderRadius: 8, minWidth: 320, maxWidth: '90vw', boxShadow: '0 2px 16px rgba(0,0,0,0.2)', position: 'relative' }}>
              <h3 style={{ marginTop: 0, fontSize: 24, fontWeight: 'bold' }}>Approve Wallet Recharge</h3>
              <div style={{ marginBottom: 16 }}>
                <label htmlFor="remarks" style={{ display: 'block', marginBottom: 8, fontWeight: 'bold' }}>Remarks:</label>
                <textarea
                  id="remarks"
                  value={approveModal.remarks}
                  onChange={e => setApproveModal(m => ({ ...m, remarks: e.target.value }))}
                  rows={3}
                  style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc', fontSize: 16 }}
                  placeholder="Enter remarks for approval"
                  disabled={approveLoading}
                />
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <button onClick={() => setApproveModal({ open: false, item: null, remarks: '' })} style={{ padding: '8px 16px', borderRadius: 4, border: 'none', background: '#ccc', cursor: approveLoading ? 'not-allowed' : 'pointer', fontSize: 16 }} disabled={approveLoading}>Cancel</button>
                <button onClick={handleApprove} style={{ padding: '8px 16px', borderRadius: 4, border: 'none', background: '#007bff', color: 'white', cursor: approveLoading ? 'not-allowed' : 'pointer', fontSize: 16, fontWeight: 'bold', position: 'relative' }} disabled={approveLoading}>
                  {approveLoading ? (
                    <span style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                      <span className="loader" style={{ width: 18, height: 18, border: '3px solid #f3f3f3', borderTop: '3px solid #007bff', borderRadius: '50%', display: 'inline-block', animation: 'spin 1s linear infinite', marginRight: 8 }} /> Approving...
                    </span>
                  ) : 'Approve'}
                </button>
              </div>
              <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }`}</style>
            </div>
          </div>
        )}
        {isLoading ? (
          <div style={{ padding: '10px 20px', fontSize: '40px', width: '100%', height: '500px', color: 'white' }}>
            <p>Loading...</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto', width: '100%' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 20, background: 'white' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid #ccc', padding: '18px 10px', fontWeight: 'bold', fontSize: 18, background: '#f5f5f5' }}>No #</th>
                  <th style={{ border: '1px solid #ccc', padding: '18px 10px', fontWeight: 'bold', fontSize: 18, background: '#f5f5f5' }}>Email</th>
                  <th style={{ border: '1px solid #ccc', padding: '18px 10px', fontWeight: 'bold', fontSize: 18, background: '#f5f5f5' }}>Module Name</th>
                  <th style={{ border: '1px solid #ccc', padding: '18px 10px', fontWeight: 'bold', fontSize: 18, background: '#f5f5f5' }}>URL</th>
                  <th style={{ border: '1px solid #ccc', padding: '18px 10px', fontWeight: 'bold', fontSize: 18, background: '#f5f5f5' }}>Status</th>
                  <th style={{ border: '1px solid #ccc', padding: '18px 10px', fontWeight: 'bold', fontSize: 18, background: '#f5f5f5' }}>Remarks</th>
                  <th style={{ border: '1px solid #ccc', padding: '18px 10px', fontWeight: 'bold', fontSize: 18, background: '#f5f5f5' }}>Created At</th>
                  <th style={{ border: '1px solid #ccc', padding: '18px 10px', fontWeight: 'bold', fontSize: 18, background: '#f5f5f5' }}>Approve</th>
                </tr>
              </thead>
              <tbody>
                {receipts.length === 0 ? (
                  <tr>
                    <td colSpan={8} style={{ textAlign: 'center', padding: 40, fontSize: 24, color: '#888', fontWeight: 'bold' }}>No data found</td>
                  </tr>
                ) : (
                  receipts.map((item: any, index) => (
                    <tr key={item._id || index}>
                      <td style={{ border: '1px solid #ccc', padding: '14px 10px', fontWeight: 500 }}>{index + 1}</td>
                      <td style={{ border: '1px solid #ccc', padding: '14px 10px', fontWeight: 500 }}>{item.email || '---'}</td>
                      <td style={{ border: '1px solid #ccc', padding: '14px 10px', fontWeight: 500 }}>{item.moduleName || '---'}</td>
                      <td style={{ border: '1px solid #ccc', padding: '14px 10px', fontWeight: 500 }}>
                        {item.url ? (
                          <img
                            src={item.url}
                            alt="thumb"
                            style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 4, cursor: 'pointer', border: '1px solid #ccc' }}
                            onClick={() => setModalImage(item.url)}
                          />
                        ) : '---'}
                      </td>
                      <td style={{ border: '1px solid #ccc', padding: '14px 10px', fontWeight: 500 }}>{item.isApproved || '---'}</td>
                      <td style={{ border: '1px solid #ccc', padding: '14px 10px', fontWeight: 500 }}>{item.remarks || '---'}</td>
                      <td style={{ border: '1px solid #ccc', padding: '14px 10px', fontWeight: 500 }}>{item.createdAt ? new Date(item.createdAt).toISOString().slice(0, 10) : '---'}</td>
                      <td style={{ border: '1px solid #ccc', padding: '14px 10px', fontWeight: 500 }}>
                        {item.isApproved === 'pending' ? (
                          <button
                            style={{ padding: '8px 18px', cursor: 'pointer', fontSize: 18, fontWeight: 'bold', borderRadius: 4, background: '#007bff', color: 'white', border: 'none' }}
                            onClick={() => setApproveModal({ open: true, item, remarks: item.remarks || '' })}
                          >
                            Approve
                          </button>
                        ) : (
                          <span style={{ color: 'green', fontWeight: 'bold', fontSize: 18 }}>Approved</span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default WalletRecharge;